import React, { createContext, useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'

export const UserContext = createContext({})

function UserProvider({ children }) {
    const [cookies, setCookie] = useCookies(['user'])
    const [first, setfirst] = useState(null)

    useEffect(() => {
        first?.login && setCookie('login', first?.login)
        first?.token && setCookie('token', first?.token)
    }, [first, setCookie])

    useEffect(() => {
        cookies?.login &&
            setfirst((prev) => ({
                ...prev,
                login: cookies?.login,
                token: cookies?.token,
            }))
    }, [cookies, setfirst])

    console.log('cookies', cookies?.login)

    return (
        <UserContext.Provider value={{ user: first, setUser: setfirst }}>
            {children}
        </UserContext.Provider>
    )
}

export default UserProvider
